export default "__VITE_ASSET__DTZZeyte__"